<template>
  <!-- 首页头部 -->
  <div class="warp">
    <div class="heads">
      <div class="heads2">
        <div class="head-logo">
          <!-- <img class="heimg" src="../assets/head-logo.png" alt="###"> -->
        </div>

        <div class="head-tab">
          <div @click="aawshow($event)" class="head-top-one">
            <span class="taba1" href="###">首页</span>
            <i v-show="xa" class="headtop-xian"></i>
          </div>

          <div @click="bbwshow($event)" class="head-top-one">
            <span class="taba2" href="###">作品中心</span>
            <i v-show="xb" class="headtop-xian"></i>
          </div>

          <div @click="ccwshow($event)" class="head-top-one">
            <span class="taba3" href="###">新闻公告</span>
            <i v-show="xc" class="headtop-xian"></i>
          </div>

          <div @click="ddwshow($event)" class="head-top-one">
            <span class="taba4" href="###">关于大赛</span>
            <i v-show="xd" class="headtop-xian"></i>
          </div>
        </div>
      </div>
      <!-- 搜索框 -->
      <div class="sousuo">
        <div class="souleft">
          <input
            class="inp"
            type="text"
            name=""
            value=""
            v-model="soutitle"
            placeholder="请输入关键词搜索"
          />
          <span @click="search()" class="soubtn">搜索</span>
          <!-- <img src="../assets/sou.png" alt="" /> -->
        </div>

        <!-- 登录注册 -->
        <div v-show="dengq" class="btnns">
          <router-link to="/zhuce">
            <button class="zhuce" type="button">注册</button>
          </router-link>
          <router-link to="/denglu">
            <button class="denglu" type="button">登录</button>
          </router-link>
        </div>
        <!-- 登录后会出现的 -->
        <div v-show="denghou" class="denghou">
          <div v-show="typeshowb" @click="gerenname()" class="denghou-logo">
            <img :src="'http://ke.yunlearning.com:8081' + touxlogo" alt="" />
          </div>
          <div v-show="typeshow" @click="gerenname()" class="denghou-logo dh-logo">
            <img :src="'http://ke.yunlearning.com:8081'+touxlogo" alt="" />
          </div>
          <span class="grnamesv">{{ grxinxiname }} </span>
          <!-- 审核状态shenheyes -->

          <span v-show="heloding" class="shenheloding">[审核中]</span>
          <!-- <span v-show="heyes" class="shenheyes">[审核通过]</span> -->
          <span v-show="henos" class="shenheno">[审核未通过]</span>

          <!-- 下拉菜单 trigger="click" -->
          <!-- 教师用户登录 -->
          <div v-show="typeshowb" class="denghou-sel">
            <el-dropdown :hide-on-click="false">
              <span @click="elupvideo()" class="el-dropdown-link gxcolor">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu class="hoverlg" slot="dropdown">
                <el-dropdown-item>
                  <span class="tuchu" @click="elupvideo()">个人中心</span>
                </el-dropdown-item>
                <el-dropdown-item>
                  <span class="tuchu" @click="tuichu()">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

          </div>

          <!-- 普通用户登录后 -->
              <div v-show="typeshow" class="denghou-sel dh-sela">
            <el-dropdown :hide-on-click="false">
              <span @click="elupvideo()" class="el-dropdown-link gxcolor">
                <i class="el-icon-arrow-down el-icon--right"></i>
              </span>

              <el-dropdown-menu class="hoverlg" slot="dropdown">

                <el-dropdown-item>
                  <span class="tuchu" @click="tuichu()">退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>
      <button v-show="typeshowb" @click="zpbut()" class="btchuanil" type="button">上传作品</button>
      <!-- 审核未通过之后出来的弹出框 -->
      <div v-show="heno" class="henobtn">
        <!-- 提示 -->
        <div class="henobtn-cont">
          <div class="henobtn-cont-au">
            <div class="henobtn-cont-title">
              <i></i> <span>您的信息审核未通过</span>
            </div>
            <div class="henobtn-cont-cont">
              <p>
                未通过原因：{{liyou}}
              </p>
            </div>
            <!-- 按钮 -->
            <div class="hebtn">
              <el-button @click="hebtnno">取消</el-button>

              <el-button @click="hebtnagain()" type="primary">重新提交</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <router-view></router-view>
  </div>
</template>

<script>
import head from "../css/HeadTop.css";
import axios from "axios";

export default {
  data() {
    return {
      homepageapis: [],
      shows: "",
      username: "",
      denghou: false,
      dengq: true,
      grxinxiname: "",
      // 审核状态
      heloding: false,
      heyes: false,
      heno: false,
      status: "", //审核状态
      oncexinxi: {},
      touxlogo: "", //头像
      soutitle: "", //搜索的内容
      xa: true,
      xb: false,
      xc: false,
      xd: false,
      henos:false,
      liyou:'',
      typeshow:false,
      typeshowb:false,
      pathcas:''

    };
  },
  components:{

  },
  computed: {
    stauser() {
      return this.$store.state.grxinxi;
    },
  },
  methods: {
       //  个人作品
 zuoponce(){

   let tokens = JSON.parse(localStorage.getItem("userinfo")).token
  //  console.log(userinfo)
   let fa = new window.FormData;
   fa.append('token',tokens);
   axios({
  method: 'post',
  url: this.$apiUrl+'/index.php/teacher/Course',
  data:fa,
  // timeout: 1000,
}).then(res =>{



  sessionStorage.setItem('status',res.data.data.status);
  sessionStorage.setItem('grid',res.data.data.id);

console.log(tokens)
// console.log(res.data.data.id)
console.log(grid)

}).catch(error =>{
// console.log(res.data.data.id)

})
 },
    zpbut(){
       let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状态
  let stutas = JSON.parse(sessionStorage.getItem('status')); //作品审核状态

  if (rzstutas == 0) {
    this.$message.error({
      message:'您的认证信息审核中，请耐心等待！！！',
      offset:200
    })
    return false

  }else if (stutas == 0) {
    this.$message.error({
      message:'作品审核中，请耐心等待！！！',
      offset:200
    })
    return false

  }else if (rzstutas == 1 && stutas == -1) {
   this.$router.push({ name: "GeRenzxone"});
      // this.$router.go(0);
      // query:{zpBc:1} },query:{zpBc:1}
  }else if (rzstutas == 1 && stutas == undefined) {
     this.$router.push({ name: "GeRenzxone"});
      // this.$router.go(0);
  }else if(this.pathcas=="/gerenzxone" && rzstutas== -1) {
          this.heno = false;
          this.$message.error({
            message:'您的信息认证失败，请前往认证信息模块重新提交！！！',
            offset:200
            })

            return false;

}else if (rzstutas == -1) {
   this.heno=true;
      return false
  }else if (stutas == 1) {
     this.$message.error({
       message:'您已有优秀作品审核通过,请勿重复提交！！！',
       offset:200
     })
  }

    },
    // 点击上传视频跳转
    elupvideo() {
      this.$router.push({ path: "/gerenzxone" });
    },
    // 搜索事件
    search() {
      // console.log(this.soutile);
      this.$store.commit("searchbtn", this.soutitle);
      this.$router.push({ path: "/zhongxin" });
    },
    aawshow($event) {
      let elchild = $event.target;
      elchild.style.color = "#0058A4FF";
      document.getElementsByClassName("taba2")[0].style.color = "black";
      document.getElementsByClassName("taba3")[0].style.color = "black";
      document.getElementsByClassName("taba4")[0].style.color = "black";

      this.xa = true;
      this.xb = false;
      this.xc = false;
      this.xd = false;
      this.$router.push({ path: "/" });
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return;
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
        let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
        if (rzstutas== -1) {
          this.heno=true;
        }
      }
    },
    bbwshow($event) {
      let elchild = $event.target;
      elchild.style.color = "#0058A4FF";
      document.getElementsByClassName("taba1")[0].style.color = "black";
      document.getElementsByClassName("taba3")[0].style.color = "black";
      document.getElementsByClassName("taba4")[0].style.color = "black";
      this.xa = false;
      this.xb = true;
      this.xc = false;
      this.xd = false;
      this.$router.push({ path: "/zhongxin" });
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return;
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
        let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
        if (rzstutas== -1) {
          this.heno=true;
        }
      }
    },
    ccwshow($event) {
      let elchild = $event.target;
      elchild.style.color = "#0058A4FF";
      document.getElementsByClassName("taba2")[0].style.color = "black";
      document.getElementsByClassName("taba1")[0].style.color = "black";
      document.getElementsByClassName("taba4")[0].style.color = "black";
      this.xa = false;
      this.xb = false;
      this.xc = true;
      this.xd = false;
      this.shows = 3;
      this.$router.push({ path: "/gaolist" });
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return;
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
        let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
        if (rzstutas== -1) {
          this.heno=true;
        }
      }
    },
    ddwshow($event) {
      let elchild = $event.target;
      elchild.style.color = "#0058A4FF";
      document.getElementsByClassName("taba2")[0].style.color = "black";
      document.getElementsByClassName("taba3")[0].style.color = "black";
      document.getElementsByClassName("taba1")[0].style.color = "black";
      this.xa = false;
      this.xb = false;
      this.xc = false;
      this.xd = true;
      this.$router.push({ path: "/dasaiall" });
      if(JSON.parse(localStorage.getItem("userinfo"))==null){
        return;
      }else if(JSON.parse(localStorage.getItem("userinfo"))){
        let rzstutas = JSON.parse(localStorage.getItem('grxinxi')).status; //信息审核状
        if (rzstutas== -1) {
          this.heno=true;
        }
      }
    },

    gerenname() {
      this.$router.push({ path: "/gerenzxone" });
    },
    // 登录成功之后判断是否有token
    htDyes() {
      if (JSON.parse(localStorage.getItem("userinfo"))) {
      let tokens = JSON.parse(localStorage.getItem("userinfo")).token;
      if (tokens == "") {
        this.denghou = false;
        this.dengq = true;
      } else if (tokens) {
        this.denghou = true;
        this.dengq = false;
        // 获取个人信息
        let fa = new window.FormData();
        fa.append("token", tokens);
        axios({
          method: "post",
          url: this.$apiUrl+"/index.php/user/userInfo", //个人信息
          data: fa,
        }).then((res) => {
          if (res.data.code == -1) {
            this.$message({
              message:res.data.msg,
              offset:200
            });
            localStorage.clear();
            this.$router.push({path:'/denglu'})
          }
          if (JSON.parse(localStorage.getItem("userinfo")).type == 1) {
             this.grxinxiname = res.data.msg.nickname;
          }else if (JSON.parse(localStorage.getItem("userinfo")).type == 2) {
            this.grxinxiname = res.data.msg.name;
          }

          this.touxlogo = res.data.msg.head_img;

          this.liyou = res.data.msg.liyou;
          // 信息审核状态存入vuex
          this.status = res.data.msg.status;

          this.$store.commit("statusloding", this.status);
          //将个人信息存入VUEX
          this.oncexinxi = res.data.msg;
          this.$store.commit("grxinxi", this.oncexinxi);
          if (this.status == 0 && JSON.parse(localStorage.getItem("userinfo")).type==2) {
            //审核中
            this.heloding = true;
            this.heno = false;
            this.heyes = false;
          } else if (this.status == 1 && JSON.parse(localStorage.getItem("userinfo")).type ==2) {
            //通过
            this.heloding = false;
            this.heno = false;
            this.heyes = true;
          }else if(this.pathcas=="/gerenzxone" && rzstutas== -1) {
          this.heno = false;

            return false;

            }else if (this.status == -1 && JSON.parse(localStorage.getItem("userinfo")).type ==2) {
            //未通过
            this.heloding = false;
            this.heyes = false;
            this.henos = true;
            this.heno = true;

          }

        });
      }
         }
    },
    //退出
    tuichu() {
      localStorage.clear();
      sessionStorage.clear();
      this.$router.push({ path: "/denglu" });
    },
    // 取消按钮
    hebtnno() {
      this.heno = false;
    },
    // 重新提交按钮
    hebtnagain() {
      this.heno = false;
      this.$router.push({ name: "GeRenzxone",query:{myTab:'gerenrenz'} });
    },
  },
  watch:{
//pathcas--当前路由地址
$route(to,from){
   this.pathcas = this.$route.path;

}
  },
  mounted() {
  this.htDyes();
if (JSON.parse(localStorage.getItem("userinfo"))) {
    this.zuoponce();
    if (JSON.parse(localStorage.getItem("userinfo")).type==1) {
            this.typeshow = true;
            this.typeshowb = false;
          }else if (JSON.parse(localStorage.getItem("userinfo")).type==2) {
              this.typeshow = false;
            this.typeshowb = true;
          }
}

  },

};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/HeadTop.vue